import styled from"@emotion/styled";import{InfoTooltip}from"@wp/src/components/common/tooltip";export const PrivateEquityNetworthFormInfoIcon=styled(InfoTooltip)`
  min-height: 14px;
  min-width: 20px;
`;